import React from "react";
import "./style.scss";

const Popup = ({ children, classname = "", visible = false, padding }) => {
  return (
    <div
      className={`${padding} popup ${classname} ${visible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
};

export default Popup;
